import React, {PureComponent} from 'react'
import SMSDisclosures from './SMSDisclosures';
import BackButton from './BackButton';

export default class SMSDisclosuresScreen extends PureComponent {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div className="container-box">
                <BackButton href="#/deliverymethods/addandedit" text="Notification Center"/>
                <SMSDisclosures/>
            </div>
        )
    }
}